import React from 'react';
import {Box, Button, IconButton, Paper} from "@mui/material";
import {ICalculatedHack, ICalculatedSpell, ICalculatedWeapon} from "../../Data/ICharacterData";
import PrebuiltWeaponCardWrapper from "./PrebuiltWeaponCardWrapper";
import PrebuiltSpellCardWrapper from "./PrebuiltSpellCardWrapper";
import IconButtonWithTooltip from "../Generic/IconButtonWithTooltip";
import {SaveOutlined} from "@mui/icons-material";
import {MdMoveDown, MdOutlineDeleteForever} from "react-icons/md";
import useCharacter from "../../Hooks/useCharacter/useCharacter";
import useAPI from "../../Hooks/useAPI/useAPI";
import PrebuiltHackCardWrapper from "./PrebuiltHackCardWrapper";

interface ISaveCardMenuPrebuiltWrapperInput {
    cardData: ICalculatedWeapon | ICalculatedSpell | ICalculatedHack
    cardType: "spell" | "weapon" | "hack",
    closeSelf: (event: React.MouseEvent) => void
}

const SaveCardMenuPrebuiltWrapper = ({cardData, cardType, closeSelf}: ISaveCardMenuPrebuiltWrapperInput) => {

    const {currentSheet} = useCharacter();
    const {CharacterAPI} = useAPI();


    const handleEquipSavedCard = (isOffhand = false) => async(event: React.MouseEvent) => {
        console.log("I COMPARE YA")
        if (currentSheet) {
            if (cardType === "weapon") {
                const weaponData = cardData as ICalculatedWeapon;
                await CharacterAPI.SetPrepWeapon(currentSheet.data._id, weaponData);
                    currentSheet.setCurrentWeapon(weaponData);
            } else if (cardType == "spell") {
                const spellData = cardData as ICalculatedSpell;
                await CharacterAPI.SetPrepSpell(currentSheet.data._id, spellData);
                currentSheet.setCurrentSpell(spellData);
            } else if (cardType == "hack") {
                const hackData = cardData as ICalculatedHack;
                await CharacterAPI.SetPrepHack(currentSheet.data._id, hackData);
                currentSheet.setCurrentHack(hackData);
            }
            closeSelf(event)
        }
    }

    const handleDeleteSavedCard = async (event: React.MouseEvent) => {
        if (currentSheet) {
            if (cardType === "weapon") {
                const weaponData = cardData as ICalculatedWeapon;

                const newArray = currentSheet.data.createdWeapons.filter(item =>
                    item.weaponBaseData.baseId !== weaponData.weaponBaseData.baseId ||
                    item.weaponCardsIds.length !== weaponData.weaponCardsIds.length ||
                    !item.weaponCardsIds.every((id, index) => id === weaponData.weaponCardsIds[index]))

                currentSheet.data.createdWeapons = newArray;

            } else if (cardType === "spell") {
                const spellData = cardData as ICalculatedSpell;
                const newArray = currentSheet.data.createdSpells.filter(item =>
                    item.spellBaseId !== spellData.spellBaseId ||
                    item.spellTargetId !== spellData.spellTargetId ||
                    !item.spellSkillsIds.every((id, index) => id === spellData.spellSkillsIds[index]))

                currentSheet.data.createdSpells = newArray;
            } else {
                const hackData = cardData as ICalculatedHack;
                const newArray = currentSheet.data.createdHacks.filter(item =>
                    item.hackFunctionId !== hackData.hackFunctionId ||
                    item.hackIOId !== hackData.hackIOId ||
                    item.hackProtocolId !== hackData.hackProtocolId ||
                    !item.hackCardsIds.every((id, index) => id === hackData.hackCardsIds[index])
                )
                currentSheet.data.createdHacks = newArray;
            }

            currentSheet.manualCharPing()
            await CharacterAPI.UpdateCharacter(currentSheet.data._id, currentSheet.data);
        }
    }


    return (
        <Box>
            <Box>
            {
                cardType === "weapon" ?
                    <PrebuiltWeaponCardWrapper weaponData={cardData as ICalculatedWeapon} overrideWidth={19}/>
                    :
                    (
                        cardType === "spell" ?
                            <PrebuiltSpellCardWrapper spellData={cardData as ICalculatedSpell} overrideWidth={19}/>
                            :
                            <PrebuiltHackCardWrapper hackData={cardData as ICalculatedHack} overrideWidth={19} />
                    )

            }
            </Box>
            <Paper elevation={3} sx={{
                borderRadius: "0 0 12px 12px",
                padding: "6px",
                marginTop: "-3px"
            }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between"
                    }}
                >
                    <IconButtonWithTooltip title={"Delete"} placement={"bottom"} onClick={handleDeleteSavedCard}><MdOutlineDeleteForever color={"firebrick"}/></IconButtonWithTooltip>
                    <Box>
                        <IconButtonWithTooltip title={"Equip"} placement={"bottom"} onClick={handleEquipSavedCard(false)}><MdMoveDown /></IconButtonWithTooltip>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
}

export default SaveCardMenuPrebuiltWrapper